/**
 * Language management mixin
 * Provides internationalization features for the application
 */
export default {
    data() {
        return {
            lang: {},                 // Dictionary of translations
            current_language: '',     // Will store the language returned from server
            language_loading: true,   // Flag to track if language is still loading
        };
    },
    
    methods: {

        detect_language_frontend() {
            // Get browser language (e.g., 'es-ES', 'en-US', 'ja-JP')
            let detected = (navigator.language || 'en').split('-')[0].toLowerCase();
            
            // Fallback to English if language not available in bundle
            if (!window.BUNDLED_LANGUAGES || !(detected in window.BUNDLED_LANGUAGES)) {
                detected = 'en';
            }
            
            return detected;
        },

        load_language_from_preferences() {
            try {
                this.language_loading = true;
                
                // Determine target language from preferences or detect from browser
                let target_language = this.preferences.interface.language_initialized 
                    ? this.preferences.interface.language 
                    : this.detect_language_frontend();
                
                // Load language from bundle (instant, no server request)
                if (window.BUNDLED_LANGUAGES && window.BUNDLED_LANGUAGES[target_language]) {
                    this.lang = window.BUNDLED_LANGUAGES[target_language];
                    this.current_language = target_language;
                } else {
                    // Fallback to English if language not in bundle
                    this.lang = window.BUNDLED_LANGUAGES['en'] || {};
                    this.current_language = 'en';
                }
                
                // Update preferences with detected language if not initialized
                if (!this.preferences.interface.language_initialized) {
                    this.preferences.interface.language = this.current_language;
                    this.preferences.interface.language_initialized = true;
                }
                
                document.documentElement.lang = this.current_language;
                this.language_loading = false;
                this.refresh_lucide();
                
            } catch (error) {
                console.error("Error loading language:", error);
                // Fallback values
                this.lang = window.BUNDLED_LANGUAGES?.['en'] || {};
                this.current_language = 'en';
                this.language_loading = false;
            }
        },


        initial_translations(){

            // SAMPLE. (Translate internal strings)
            // this.shop_buttons = {
            //     free: this.get_t('shop_buttons.free'),
            //     silver: this.get_t('shop_buttons.silver'),
            //     gold: this.get_t('shop_buttons.gold'),
            //     diamond: this.get_t('shop_buttons.diamond')
            // };

        },

        get_t(key, placeholders = {}) {
            // Validate key parameter
            if (!key || typeof key !== 'string') {
                console.warn(`Invalid translation key: ${key}`);
                return "N/A";
            }

            // Split the key into parts for nested access
            const keys = key.split('.');
            let text = this.lang;

            // Navigate the object to find the value
            for (const k of keys) {
                if (text[k]) {
                    text = text[k];
                } 
                else {
                    if (this.language_loading == false)
                    {
                        console.warn(`Translation key not found: ${key}`);
                    }
                    return "N/A";
                } 
            }

            // Replace placeholders (e.g., {gold_cost})
            for (const [placeholder, value] of Object.entries(placeholders)) {
                text = text.replace(`{${placeholder}}`, value);
            }

            return text;
        },

        change_language(language_code, save = true) {
            // Update preferences
            this.preferences.interface.language = language_code;
            this.preferences.interface.language_initialized = true;
            
            // Reload language from preferences
            this.load_language_from_preferences();
            
            // Save preferences if requested
            if (save) {
                this.$nextTick(() => {
                    this.save_preferences();
                });
            }
        },

    }
};